export default __webpack_public_path__ + "static/media/unchecked.7b52bbc7.svg";